module.exports = __webpack_public_path__ + "img/rules.867676eb.svg";